import { render } from "./PageSpinner.vue?vue&type=template&id=0440c841&scoped=true"
import script from "./PageSpinner.vue?vue&type=script&lang=js"
export * from "./PageSpinner.vue?vue&type=script&lang=js"

import "./PageSpinner.vue?vue&type=style&index=0&id=0440c841&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0440c841"]])

export default __exports__